module.exports = __webpack_public_path__ + "img/zi.1db8cbb2.png";